// extracted by mini-css-extract-plugin
export default {"wrapper":"LaborActivities_wrapper__07YSK","wrapper__button":"LaborActivities_wrapper__button__DPWhC","error":"LaborActivities_error__qxYny","info":"LaborActivities_info__NMG9n"};